import React, { useEffect } from "react";
import { Box, MainTitle } from "app/components/common";
import i18n from "@microdoing/shared/i18n";
import { useDispatch, useSelector } from "react-redux";
import UserRankingRow from "./UserRankingRow";
import { getUserRankingRequest } from "@microdoing/shared/services/ranking/actions";
import {
  getUserId,
  getUserExperience,
} from "@microdoing/shared/services/user/selectors";
import { getCampaignId } from "@microdoing/shared/services/userCampaign/selectors";
import { getFirstUserRankings } from "@microdoing/shared/services/ranking/selectors";
import { requestExternalUser } from "@microdoing/shared/services/externalProfile/actions";
import { useNavigation } from "@react-navigation/native";
import SeeAll from "app/components/common/SeeAll";

const Ranking = ({}) => {
  const firstUserRankings = useSelector(getFirstUserRankings);
  const campaignId = useSelector(getCampaignId);
  const userId = useSelector(getUserId);
  const experience = useSelector(getUserExperience);

  const dispatch = useDispatch();
  const navigation = useNavigation();

  useEffect(() => {
    dispatch(getUserRankingRequest({ userId, campaignId, page: 0, limit: 10 }));
  }, [campaignId, userId, getUserRankingRequest, experience]);

  const navigateExternalProfile = id => () => {
    if (id === userId) {
      navigation.navigate("UserProfile");
    } else if (id) {
      dispatch(requestExternalUser({ userId: id }));
    }
  };

  return (
    <Box
      backgroundColor="neutral.white"
      borderRadius={10}
      paddingTop="xm"
      paddingBottom="xs"
    >
      <Box
        flex={1}
        paddingHorizontal="m"
        alignItems="center"
        justifyContent="space-between"
        flexDirection="row"
        marginBottom="s"
      >
        <MainTitle variant="l6-bold">{i18n.t("Ranking")}</MainTitle>
        <SeeAll navigationRoute="UserRanking" />
      </Box>
      {firstUserRankings.map((user, index) => {
        return (
          <Box key={index}>
            <UserRankingRow
              user={user}
              rank={index + 1}
              key={user._id}
              isUser={userId === user._id}
              onPress={navigateExternalProfile(user._id)}
            />
            {index !== firstUserRankings.length - 1 && (
              <Box borderTopWidth={1} borderTopColor="neutral.75" />
            )}
          </Box>
        );
      })}
    </Box>
  );
};

export default Ranking;
